/*
 * newsbot - Authors section for filter details
 * Match or exclude stories by article author
 */

import { useFormikContext } from "formik";
import { CollapsibleSection, FilterLayoutClass, FilterTightGridGapClass } from "@/components/filters/_components";
import { TextAreaAutoResize } from "@/components/inputs/input";
import { Select } from "@/components/inputs/select";
import { classNames } from "@utils";

const matchLogicOptions = [
  { label: "Match ANY author", value: "ANY" },
  { label: "Match ALL authors", value: "ALL" },
];

interface AuthorsFormValues {
  match_authors: string;
  except_authors: string;
  authors_match_logic: 'ANY' | 'ALL';
  authors_except_logic: 'ANY' | 'ALL';
}

export const Authors = () => {
  const { values } = useFormikContext<AuthorsFormValues>();

  return (
    <CollapsibleSection
      defaultOpen={values.match_authors?.length > 0 || values.except_authors?.length > 0}
      title="Authors"
      subtitle="Match or exclude stories by article author"
    >
      <div className={classNames("sm:col-span-6", FilterLayoutClass, FilterTightGridGapClass)}>
        <TextAreaAutoResize
          name="match_authors"
          label="Match authors"
          columns={8}
          placeholder="Jane Doe, John Smith"
          tooltip={<p>Comma-separated author names to match</p>}
        />
        <Select
          name="authors_match_logic"
          label="Match logic"
          columns={4}
          options={matchLogicOptions}
          optionDefaultText="any"
        />
      </div>
      <div className={classNames("sm:col-span-6", FilterLayoutClass, FilterTightGridGapClass)}>
        <TextAreaAutoResize
          name="except_authors"
          label="Except authors"
          columns={8}
          placeholder="Bot Writer, PR Team"
          tooltip={<p>Stories by these authors are excluded</p>}
        />
        <Select
          name="authors_except_logic"
          label="Except logic"
          columns={4}
          options={matchLogicOptions}
          optionDefaultText="any"
        />
      </div>
    </CollapsibleSection>
  );
};
